module.exports = __webpack_public_path__ + "assets/images/premium-features/labor-cost-banner-new-b03292.png";